const Caption: React.FC<{
  children: string | JSX.Element[];
}> = ({ children }) => (
  <div className="micro text-secondary oip-text-max-width pt-8">{children}</div>
);

export default Caption;
